/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Status_ModifiedInputs */

const id_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diubah`)
};

const ms_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diubah`)
};

const da_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændret`)
};

const de_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert`)
};

const en_us2_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified`)
};

const es_es2_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado`)
};

const es_mx2_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado`)
};

const fil_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binago`)
};

const fr_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifié`)
};

const it_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificato`)
};

const hu_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módosítva`)
};

const nl_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewijzigd`)
};

const no_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endret`)
};

const pl_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmodyfikowane`)
};

const pt_br2_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado`)
};

const pt_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado`)
};

const ro_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificat`)
};

const fi_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokattu`)
};

const sv_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändrad`)
};

const vi_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sửa đổi`)
};

const tr_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştirildi`)
};

const cs_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravené`)
};

const bg_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Променени`)
};

const ru_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменено`)
};

const uk_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінено`)
};

const ar_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معدّل`)
};

const hi_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदले गए`)
};

const th_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไขแล้ว`)
};

const ja_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

const zh_cn2_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已修改`)
};

const zh_hant1_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已修改`)
};

const ko_builds_comparison_status_modified = /** @type {(inputs: Builds_Comparison_Status_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정됨`)
};

/**
* | output |
* | --- |
* | "Modified" |
*
* @param {Builds_Comparison_Status_ModifiedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_status_modified = /** @type {((inputs?: Builds_Comparison_Status_ModifiedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Status_ModifiedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_status_modified(inputs)
	if (locale === "ms") return ms_builds_comparison_status_modified(inputs)
	if (locale === "da") return da_builds_comparison_status_modified(inputs)
	if (locale === "de") return de_builds_comparison_status_modified(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_status_modified(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_status_modified(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_status_modified(inputs)
	if (locale === "fil") return fil_builds_comparison_status_modified(inputs)
	if (locale === "fr") return fr_builds_comparison_status_modified(inputs)
	if (locale === "it") return it_builds_comparison_status_modified(inputs)
	if (locale === "hu") return hu_builds_comparison_status_modified(inputs)
	if (locale === "nl") return nl_builds_comparison_status_modified(inputs)
	if (locale === "no") return no_builds_comparison_status_modified(inputs)
	if (locale === "pl") return pl_builds_comparison_status_modified(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_status_modified(inputs)
	if (locale === "pt") return pt_builds_comparison_status_modified(inputs)
	if (locale === "ro") return ro_builds_comparison_status_modified(inputs)
	if (locale === "fi") return fi_builds_comparison_status_modified(inputs)
	if (locale === "sv") return sv_builds_comparison_status_modified(inputs)
	if (locale === "vi") return vi_builds_comparison_status_modified(inputs)
	if (locale === "tr") return tr_builds_comparison_status_modified(inputs)
	if (locale === "cs") return cs_builds_comparison_status_modified(inputs)
	if (locale === "bg") return bg_builds_comparison_status_modified(inputs)
	if (locale === "ru") return ru_builds_comparison_status_modified(inputs)
	if (locale === "uk") return uk_builds_comparison_status_modified(inputs)
	if (locale === "ar") return ar_builds_comparison_status_modified(inputs)
	if (locale === "hi") return hi_builds_comparison_status_modified(inputs)
	if (locale === "th") return th_builds_comparison_status_modified(inputs)
	if (locale === "ja") return ja_builds_comparison_status_modified(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_status_modified(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_status_modified(inputs)
	return ko_builds_comparison_status_modified(inputs)
});
export { builds_comparison_status_modified as "builds.comparison.status.modified" }